import { Component } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

// import { timer } from 'rxjs';

import {
    AuthService,
    EventsService,
    //    IoniconsService,      // Needed for Ionic 7
    LocalStorageService,
    SessionService,
    UxHelperService
} from '@shared/services';
import type { TResponse } from '@shared/models';
import { Constants } from '@shared/models';

@Component({
    'selector': 'app-root',
    'templateUrl': 'app.component.html',
    'styleUrls': ['./app.component.scss'],
    'standalone': true,
    'imports': [ IonicModule, CommonModule, FormsModule ]
})
export class AppComponent implements OnInit, OnDestroy {
    private startupPage = 'Accounts';
    public selectedRouteUrl = '';
    public activePageTitle = this.startupPage;
    private subscriptions: Subscription[] = [];
    public vm = {
        dealershipName: ' ',
        firstName: ' '
    };
    public appPages = [
        // { title: 'Dashboard',  url: '/dashboard',   icon: 'home'             },
        { title: 'Accounts', url: '/accounts', icon: 'card' },
        { title: 'Crm', url: '/crm/tabs', icon: 'people-outline' },
        { title: 'Settings', url: '/settings', icon: 'construct' },
        { title: 'Tests', url: '/tests', icon: 'pulse' },
        { title: 'Logout', url: '/logout', icon: 'close' }
    ];

    constructor(private platform: Platform,  private eventsService: EventsService,
        private sessionService: SessionService, private uxHelperService: UxHelperService,
        private localStorageService: LocalStorageService, public authService: AuthService,
        private router: Router) {
        // this.initializeApp();
    }

    // public initializeApp() {
    //     this.platform.ready().then(() => {
    //         // do nothing
    //     });
    // }

    public async ngOnInit(): Promise<void> {
        this.subscriptions.push(
            this.eventsService.subscribe(Constants.EVENT_LOGIN, () => this.onLoginEvent())
        );
        this.subscriptions.push(
            this.eventsService.subscribe(Constants.EVENT_PAGE_LOADED, (viewName) => this.onPageLoadedEvent(viewName))
        );
        await this.localStorageService.initialize();
        // this.events.subscribe(Constants.INTERNET_CONNECTION_CHANGE_EVENT, (connected) => { this.onInternetConnectionChange(connected);});
        // If the logged in users details were changed, then display the new user details in the side menu.
        // events.subscribe(Constants.LOGGED_IN_USER_CHANGED_EVENT, (role) => { this.onLoginEvent(role); });
        // this.router.events.subscribe((event: RouterEvent) => {
        //     if (event && event.url) {
        //         this.selectedRouteUrl = event.url;
        //     }
        // });
    }

    public ngOnDestroy(): void {
        this.unsubscribeAll();
    }

    // 1) If the account is expired then show the expired view
    // 2) If the dealership has not made a payment yet, then show the introduction view which is a mini sales page.
    // 3) If the role is 'Accountant' show the Accounts Page
    // 4) Otherwise, show the tickets/dashboard view.
    private async onLoginEvent() {
        this.vm.dealershipName = this.sessionService.getDealership().dealershipName;
        this.vm.firstName = this.sessionService.getCurrentUser().firstName;
        this.sessionService.setApp('backend');

        // // Permissions
        // const authorized = this.permissionsService.getPermission(role);
        // if (!authorized) {
        //     this.router.navigateByUrl('expired');
        //     return;
        // }

        // // Show starting page
        // switch (standing) {
        //     case 'Settings':
        //         this.router.navigateByUrl('settings');
        //         break;

        //     case 'Expired':
        //         this.router.navigateByUrl('expired');
        //         break;

        //     case 'Prospect':
        //         // this.router.navigateByUrl('introduction');
        //         this.router.navigateByUrl('navigationPage1');
        //         break;

        //     default:
        //         if (role === 'Accountant') {
        //             this.router.navigateByUrl('accountant');
        //         } else {
        //             this.router.navigateByUrl('tickets');
        //         }
        //         break;
        // }
    }

    private onPageLoadedEvent(viewName) {
        this.activePageTitle = viewName;
    }

    public onMenuItemClick(page: any) {
        // if (page.url) {
        //     console.log('Clicked ' + page.title);
        //     this.router.navigateByUrl(page.url);
        // } else {
        //     this.confirmLogout();
        //     // logout
        //     console.log('Clicked logout');
        // }
        // console.log('Clicked ' + page.url);
        if (page.url === '/logout') {
            this.confirmLogout();
        } else {
            this.router.navigateByUrl(page.url);
        }
    }

    public async confirmLogout() {
        const title = 'Confirm Logout';
        const message = 'Are you sure you want to log out?';
        const response = await this.uxHelperService.showAlert(title, message);
        if (response.okay) {
            await this.authService.logout();            // This throws the permissions error!
            // this.eventsService.unsubscribeAll();
            this.unsubscribeAll();
            this.activePageTitle = null;
            this.router.navigateByUrl('/login');
            window.location.reload();
        }
    }

    private unsubscribeAll() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptions = [];
    }
}
